<template>
  <div class="form-row">
    <form :class="{ 'loading-opacity': preloader, 'col-sm-10 p-4': isAdmin, 'col-md-12 mb-0': !isAdmin }">
      <div class="form-group">
        <h3 class="text-center mb-0">
          Bank Details
        </h3>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-sm-6 mb-sm-0">Beneficiary Name</label>
        <app-input class="col-sm-8"
                   type="text"
                   v-model="payroll_info.account_name"
                   placeholder=""/>
      </div>
      <div class="form-group row align-items-center">
        <label class="col-sm-6 mb-sm-0">Bank Account Number: E.G. 12345678</label>
        <app-input class="col-sm-8"
                   type="text"
                   @keyup="(event) => textOnChange(event, 'account_number', validationType.AlphaNumeric)"
                    :required="true"
                   :max-length=8
                   v-model="payroll_info.account_number"
                   placeholder="Account Number"/>
      </div>
      <div class="form-group row align-items-center">
        <label class="col-sm-6 mb-sm-0">Bank Sort Code: E.G. 12-34-56</label>
        <app-input class="col-sm-8"
                   type="text"
                   :max-length=8
                   @input="formatInput"
                   :required="true"
                   v-model="payroll_info.sort_code"
                   placeholder="Sort Code (Numbers only)"/>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-sm-6 mb-sm-0">Name of Bank</label>
        <app-input class="col-sm-8"
                   type="text"
                   :required="true"
                   @keyup="(event) => textOnChange(event, 'bank_name', validationType.Alphabet)"
                   v-model="payroll_info.bank_name"
                   placeholder="Bank Name"/>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-sm-6 mb-sm-0">Other Information</label>
        <app-input class="col-sm-8"
                   type="textarea"
                   v-model="payroll_info.other_information"
                   placeholder="Others"/>
      </div>
    </form>
    <form class="col-sm-2" v-if="isAdmin">
      <drawer-component title="Comments" size="40%">
        <general-comments
            :comments="payroll_info.screening_status"
            :emailAddress="emailAddress"
            :applicantId="candidateId"
            :statusable_type="payroll_info.statusable_type"
            :statusable_id="payroll_info.id"/>
      </drawer-component>
    </form>
  </div>
</template>

<script>
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {
  validateAlphabet,
  validateAlphaNumeric,
} from "@Views/Screening/utility/common/candidate";
import {validationType} from "@Views/Screening/utility/enums";

export default {
  name: "ScreeningStepFive",
  mixins: [FormMixin],
  props: {
    preloader: {
      type: Boolean,
      default: false
    },
    payroll_info: {
      type: Object,
      required: true
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    candidateId: {
      type: Number,
    },
    emailAddress: {
      type : String
    }
  },
  data() {
    return {
      validationType: validationType,
      validation: {},
    };
  },
  methods: {
    validateAlphaNumeric,
    validateAlphabet,

    textOnChange(event, model, validationType) {
      const text = event?.target.value;
      if (text) {
        if (validationType === this.validationType.AlphaNumeric) {
          this.validation[model] = this.validateAlphaNumeric(text);
        }else if (validationType === this.validationType.Alphabet) {
          this.validation[model] = this.validateAlphabet(text);
        }else if (validationType === this.validationType.Numeric) {
          this.validation[model] = this.validateNumeric(text);
        }else if (validationType === this.validationType.Email) {
          this.validation[model] = this.validateEmail(text);
        }
        if(!this.validation[model]){
          this.$set(this.payroll_info, model, text.slice(0, -1));
          // event.preventDefault();
        }
        this.$set(this.validation, model, this.validation[model]);
      }
    },

    formatInput() {
      // Remove all non-digit characters
      let input = this.payroll_info.sort_code.replace(/\D/g, '');

      // Ensure the input doesn't exceed 6 digits
      if (input.length > 6) {
        input = input.slice(0, 6);
      }

      // Format the input into 12-34-56
      if (input.length > 2 && input.length <= 4) {
        input = input.replace(/(\d{2})(\d+)/, '$1-$2');
      } else if (input.length > 4) {
        input = input.replace(/(\d{2})(\d{2})(\d+)/, '$1-$2-$3');
      }

      // Set the formatted input back to the input field
      this.payroll_info.sort_code = input;
    }
  },


}
</script>